import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  ButtonResponsiveWrapper,
  RoundPendingIcon,
  Text,
  useResponsive,
} from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';

const HEADER = 'Your request has been submitted for additional review';
const DESCRIPTION = 'You can check on the status of this request under account activity.';

interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export const ClaimPlaidWarningModal: React.FC<Props> = ({ visible, onSetVisible, onSubmit, onCancel }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  return (
    <ModalWrapper testId="ClaimPlaidWarningModal" visible={visible} onSetVisible={onSetVisible}>
      <Box align="center" pad="spacing24">
        <RoundPendingIcon color="warning" />
        <Box pad={isMobile ? {} : { horizontal: '100px' }}>
          <Text
            data-testid="ClaimPlaidWarningModal_modal_header"
            margin={isMobile ? {} : { vertical: 'spacing12' }}
            textAlign="center"
            size="24px"
            weight={700}
          >
            {t(HEADER)}
          </Text>
        </Box>

        <Text
          data-testid="ClaimPlaidWarningModal_modal_help-text"
          margin={{ bottom: 'spacing24' }}
          textAlign="center"
        >
          {t(DESCRIPTION)}
        </Text>
        <ButtonResponsiveWrapper fill align="center" justify="center" gap="spacing12">
          <AppButton
            fill={isMobile}
            buttonType="secondary"
            testId="ClaimPlaidWarningModal_modal_cancel"
            onClick={onCancel}
            width="200px"
          >
            {t('Go to Home')}
          </AppButton>
          <AppButton
            fill={isMobile}
            testId="ClaimPlaidWarningModal_modal_submit"
            onClick={onSubmit}
            width="200px"
          >
            {t('Go to Expense Details')}
          </AppButton>
        </ButtonResponsiveWrapper>
      </Box>
    </ModalWrapper>
  );
};
